import React, { Component } from 'react';

import { history } from '../../../state/store';
import AuthApi from '../../../api/auth';
import AuthService from '../../../state/auth.service';
import Button from '../../form/Button';
import Message from '../../form/Message';

class ResetConfirmForm extends Component {
    constructor(props, context) {
        super(props, context);

        const initialEmail = AuthService.getEmail() || '';
        this.state = {
            email: initialEmail,
            code: '',
            password: '',
            passwordconfirm: '',
            pwlen: false,
            uppercase: false,
            lowercase: false,
            number: false,
            special: false,
        };

        this.onChange = this.onChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onChange(evt, checkPw) {
        let changes = {};
        changes[evt.target.name] = evt.target.value;
        this.setState(changes);
        if (checkPw) {
            this.checkPw(evt.target.value);
        }
    }
    checkPw(pw) {
        let changes = {
            pwlen: pw.length > 7,
            lowercase: pw.search(/[a-z]/) > -1,
            uppercase: pw.search(/[A-Z]/) > -1,
            number: pw.search(/[0-9]/) > -1,
            special: pw.search(/[^0-9a-zA-Z]/) > -1,
        };
        console.log(changes);
        this.setState(changes);
    }

    onFormSubmit(event) {
        event.preventDefault();

        const { email, code, password } = this.state;

        if (password !== this.state.passwordconfirm) {
            return this.setState({
                errorMessage: 'Password and Confirmation do not match',
                isbusy: false,
            });
        } else if (!this.state.pwlen) {
            return this.setState({
                errorMessage: 'Password needs to be at least 8 characters long',
                isbusy: false,
            });
        } else if (!this.state.lowercase) {
            return this.setState({
                errorMessage: 'Password needs a lowercase character',
                isbusy: false,
            });
        } else if (!this.state.uppercase) {
            return this.setState({
                errorMessage: 'Password needs an uppercase character',
                isbusy: false,
            });
        } else if (!this.state.number) {
            return this.setState({
                errorMessage: 'Password needs a number',
                isbusy: false,
            });
        } else if (!this.state.special) {
            return this.setState({
                errorMessage:
                    'Password needs a special character (!@#$%^&*()_+=-`~/?.>,<;:\'"[{]}|\\)',
                isbusy: false,
            });
        }
        this.setState({ errorMessage: null, isbusy: true }, () => {
            AuthApi.confirm(email, code, password)
                .then(() => {
                    this.setState({ errorMessage: null, isbusy: false });
                    history.push('/');
                })
                .catch(errorMessage => {
                    this.setState({
                        errorMessage: errorMessage,
                        isbusy: false,
                    });
                });
        });
    }

    render() {
        return (
            <form onSubmit={this.onFormSubmit}>
                <div className="form__field">
                    <label htmlFor="email">Email Address</label>
                    <input
                        type="email"
                        name="email"
                        placeholder="you@example.com"
                        autoCapitalize="off"
                        autoCorrect="off"
                        autoFocus="autofocus"
                        required="required"
                        value={this.state.email}
                        onChange={evt => this.onChange(evt, false)}
                    />
                </div>

                <div className="form__field">
                    <label htmlFor="code">Confirmation Code</label>
                    <input
                        type="text"
                        name="code"
                        placeholder="123456"
                        autoCapitalize="off"
                        autoCorrect="off"
                        autoFocus="autofocus"
                        required="required"
                        onChange={evt => this.onChange(evt, false)}
                    />
                </div>

                <div className="form__field">
                    <label htmlFor="password">New Password:</label>
                    <input
                        type="password"
                        name="password"
                        autoComplete="off"
                        placeholder="password"
                        required="required"
                        onChange={evt => this.onChange(evt, true)}
                    />
                </div>

                <div className="form__field">
                    <label htmlFor="passwordconfirm">Confirm Password:</label>
                    <input
                        type="password"
                        name="passwordconfirm"
                        autoComplete="off"
                        placeholder="password"
                        required="required"
                        onChange={evt => this.onChange(evt, true)}
                    />
                </div>

                <div className="form__field">
                    * Password Requirements:
                    <ul>
                        <li>
                            8 characters comprised of at least:{' '}
                            <i
                                className={
                                    !this.state.pwlen
                                        ? ''
                                        : 'fa fa-check-circle'
                                }
                            />
                        </li>
                        <li>
                            1 upper-case character{' '}
                            <i
                                className={
                                    !this.state.uppercase
                                        ? ''
                                        : 'fa fa-check-circle'
                                }
                            />
                        </li>
                        <li>
                            1 lower-case character{' '}
                            <i
                                className={
                                    !this.state.lowercase
                                        ? ''
                                        : 'fa fa-check-circle'
                                }
                            />
                        </li>
                        <li>
                            1 number{' '}
                            <i
                                className={
                                    !this.state.number
                                        ? ''
                                        : 'fa fa-check-circle'
                                }
                            />
                        </li>
                        <li>
                            1 special character{' '}
                            <i
                                className={
                                    !this.state.special
                                        ? ''
                                        : 'fa fa-check-circle'
                                }
                            />
                        </li>
                    </ul>
                </div>

                <div className="form__buttons">
                    <Button
                        type="submit"
                        defaultText="Reset password"
                        busyText="Resetting password"
                        isbusy={this.state.isbusy}
                    />
                </div>

                <div className="form__footer">
                    <Message error={this.state.errorMessage} />
                </div>
            </form>
        );
    }
}

export default ResetConfirmForm;
